import { Attachment } from '@/models/Attachment';
import { LanguageType } from '@/models/LanguageType';

export enum AttachmentsTypes {
    GET_ATTACHMENTS_REQUEST = '@attachments/GET_ATTACHMENTS_REQUEST',
    GET_ATTACHMENTS_SUCCESS = '@attachments/GET_ATTACHMENTS_SUCCESS',
    GET_ATTACHMENTS_FAILURE = '@attachments/GET_ATTACHMENTS_FAILURE',

    POST_ATTACHMENT_REQUEST = '@attachments/POST_ATTACHMENT_REQUEST',
    POST_ATTACHMENT_SUCCESS = '@attachments/POST_ATTACHMENT_SUCCESS',
    POST_ATTACHMENT_FAILURE = '@attachments/POST_ATTACHMENT_FAILURE',

    ADD_TO_ATTACHMENT_LIST = '@attachments/ADD_TO_ATTACHMENT_LIST',
    REMOVE_ATTACHMENT_FROM_LIST = '@attachments/REMOVE_ATTACHMENT_FROM_LIST',

    ATTACHMENTS_CLEAR = '@attachments/ATTACHMENTS_CLEAR',

    REMOVE_ATTACHMENT_REQUEST = '@attachments/REMOVE_ATTACHMENT_REQUEST',
    REMOVE_ATTACHMENT_SUCCESS = '@attachments/REMOVE_ATTACHMENT_SUCCESS',
    REMOVE_ATTACHMENT_FAILURE = '@attachments/REMOVE_ATTACHMENT_FAILURE',

    PUT_ATTACHMENT_REQUEST = '@attachments/PUT_ATTACHMENT_REQUEST',
    PUT_ATTACHMENT_SUCCESS = '@attachments/PUT_ATTACHMENT_SUCCESS',
    PUT_ATTACHMENT_FAILURE = '@attachments/PUT_ATTACHMENT_FAILURE',
}

export interface AttachmentsState {
    data: Attachment[];
    loading: boolean;
    hasError: boolean;
    success: boolean | undefined;
}

export interface AttachmentRequest {
    id: number;
    name: string;
    entityId?: number;
    path?: string;
    locale: LanguageType;
    contentId?: number;
}
